import { IconX } from '@tabler/icons-react-native';
import { guestLocationHintDismissedAtom } from 'app/atoms/guest-session';
import { Column, Row } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import { useTheme } from 'app/shopify';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

export function GuestLocationHint({ hidden, compact = false }: { hidden: boolean; compact?: boolean }) {
  const [dismissed, setDismissed] = useAtom(guestLocationHintDismissedAtom);
  const { t } = useTranslation('all-listings');
  const { t: tAccessibility } = useTranslation('accessibility');
  const theme = useTheme();
  if (hidden || dismissed) return null;
  return (
    <Column
      position="absolute"
      top="100%"
      right={compact ? 0 : undefined}
      left={compact ? undefined : '50%'}
      width={compact ? 286 : 340}
      style={compact ? undefined : { transform: [{ translateX: -170 }] }}
      zIndex={600}
      testID="guest-location-hint"
    >
      <Column
        alignSelf={compact ? 'flex-end' : 'center'}
        style={{
          marginRight: compact ? 12 : 0,
          width: 0,
          height: 0,
          borderLeftWidth: 8,
          borderRightWidth: 8,
          borderBottomWidth: 10,
          borderLeftColor: 'transparent',
          borderRightColor: 'transparent',
          borderBottomColor: theme.colors['surface.brand.default'],
        }}
      />
      <Row
        backgroundColor="surface.brand.default"
        borderRadius="radius.sm"
        padding="spacing.general.x4"
        gap="spacing.general.x4"
        alignItems="center"
        shadowColor="black"
        shadowOpacity={0.12}
        shadowRadius={8}
        shadowOffset={{ width: 0, height: 4 }}
      >
        <Text color="text.inverse.primary" variant="bodySmallMedium" flex={1}>
          {t('guest.locationHint')}
        </Text>
        <Button
          accessibilityLabel={tAccessibility('close')}
          onPress={() => setDismissed(true)}
          variant="plain"
          height={32}
          width={32}
        >
          <IconX color={theme.colors['icon.inverse.primary']} size={20} strokeWidth={ICON_STROKE_WIDTH} />
        </Button>
      </Row>
    </Column>
  );
}
